import { axiosClient } from "services/axios";

export function deleteArticle(articleid: string | number) {
  return axiosClient.delete("article/", {
    params: { articleid: Number(articleid) },
  });
}
